<template>
    <div class="container">
        <main>
            <div class="row subscriptions-container">
                <div class="col-12">
                    <div class="page-header">
                        <router-link to="/subscription" class="go-back-btn w-100"><i class="fas fa-chevron-left"></i> {{ $t('Назад') }}</router-link>
                        <h1 class="w-100">{{ $t('Оформление подписки') }}</h1>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div :class="['plan', plan.theme]" v-if="plan">
                        <div class="plan-header">
                            <div class="plan-info">
                                <h4 v-text="$t(plan.name)"></h4>
                            </div>
                        </div>

                        <div class="plan-body">
                            <div class="row">
                                <div :class="{'col-lg-6': plan.features !== null, 'col-12': plan.features === null}">
                                    <p v-html="$t(plan.description)"></p>
                                </div>
                                <div class="col-lg-6" v-if="plan.features !== null">
                                    <ul class="check-list">
                                        <li v-for="(feature, index) in plan.features" :key="index"><i class="fas fa-check"></i> {{ $t(feature) }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        <div class="plan-footer" v-if="plan.price !== null">
                            <div class="row align-items-center">
                                <div class="col-lg-6" v-if="plan.price !== null">
                                    <div class="price">{{ plan.price | money }} <i class="fas fa-hryvnia"></i></div>
                                    <span>{{ $t('в месяц') }}</span>
                                </div>
                                <div class="col-lg-6 text-right ml-auto">
                                    <span class="text-muted"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 coupon-form-block" v-if="! coupon">
                    <p class="mt-3 pb-2 border-bottom">{{ $t('Если у вас есть промокод, вы можете использовать его при оформлении подписки введя в поле ниже и активировав') }}</p>
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="promoInput" :placeholder="$t('Введите промокод')">
                    </div>
                    <button class="btn btn-outline-success w-100" @click.prevent="checkPromoCode" :disabled="promoBtnDisabled">{{ $t('Применить') }}</button>
                </div>
                <div class="col-lg-5 coupon-form-block" v-else>
                    <p class="mt-3">{{ $t('Вы активировали промокод') }}: <b v-text="coupon.code"></b></p>
                    <p class="text-muted coupon-item" v-if="coupon.days > 0">{{ $t('При активации подписки вы получите') }} <b>{{ coupon.days }}</b> {{ $t('дополнительных дней') }}.</p>
                    <p class="text-muted coupon-item" v-if="coupon.discount > 0">{{'При активации подписки вы получите'}} <b>{{ coupon.discount }}</b>% скидки при оплате.</p>
                    <button class="btn btn-outline-danger w-100 mt-3"><i class="fas fa-trash"></i> {{ $t('Удалить промокод') }}</button>
                </div>
                <div class="col-12" v-if="cards.length > 0">
                    <div class="border-top w-100 pt-3">
                        <h3>{{ $t('Выберите карту для оплаты') }}</h3>

                        <div class="user-cards select-card row mb-3">
                            <div class="col-lg-6 mobile-px-0" @click="card = item" v-for="item in cards" :key="item.id">
                                <div :class="{'card p-3': true, 'border border-primary': item.id === card.id}">
                                    <div class="info-side">
                                        <div class="w-100">
                                            <svg width="30" height="24" viewBox="0 0 39 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2" v-if="item.system === 'mastercard'">
                                                <path d="M38.6082 19.386V18.9218H38.4868L38.3465 19.2406L38.2068 18.9218H38.0847V19.386H38.171V19.0359L38.3022 19.338H38.3915L38.5227 19.0352V19.386H38.6082ZM37.8383 19.386V19.0009H37.9939V18.9225H37.5972V19.0009H37.7528V19.386H37.8383Z" fill="#F79410"/>
                                                <path d="M24.8127 21.3828H14.3124V2.56079H24.8127V21.3828Z" fill="#FF5F00"/>
                                                <path d="M14.9852 11.9703C14.9852 8.15215 16.7775 4.75106 19.5686 2.55927C17.5275 0.95652 14.9516 -0.000104904 12.1521 -0.000104904C5.52451 -0.000104904 0.1521 5.35913 0.1521 11.9703C0.1521 18.5814 5.52451 23.9407 12.1521 23.9407C14.9516 23.9407 17.5275 22.984 19.5686 21.3813C16.7775 19.1895 14.9852 15.7884 14.9852 11.9703Z" fill="#EB001B"/>
                                                <path d="M38.9744 11.9703C38.9744 18.5814 33.602 23.9407 26.9744 23.9407C24.1749 23.9407 21.599 22.984 19.5571 21.3813C22.349 19.1895 24.1413 15.7884 24.1413 11.9703C24.1413 8.15216 22.349 4.75107 19.5571 2.55928C21.599 0.95653 24.1749 -9.53674e-05 26.9744 -9.53674e-05C33.602 -9.53674e-05 38.9744 5.35914 38.9744 11.9703Z" fill="#F79E1B"/>
                                            </svg>
                                            <svg width="30" height="23" viewBox="0 0 70 23" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2" v-if="item.system === 'visa'">
                                                <g clip-path="url(#clip0)">
                                                    <path d="M30.3333 22.6682H24.6628L28.2095 0.403564H33.8797L30.3333 22.6682Z" fill="#00579F"/>
                                                    <path d="M50.8893 0.947893C49.7709 0.4974 47.9969 0 45.8033 0C40.2035 0 36.2602 3.03162 36.236 7.36592C36.1895 10.5638 39.0593 12.3399 41.2057 13.4062C43.3996 14.4957 44.1453 15.2069 44.1453 16.1781C44.123 17.6696 42.3726 18.3572 40.74 18.3572C38.4761 18.3572 37.263 18.0027 35.4196 17.1729L34.6729 16.8171L33.8794 21.8151C35.2093 22.4302 37.6596 22.9761 40.2035 23C46.1534 23 50.027 20.0153 50.0729 15.3964C50.0955 12.8619 48.5801 10.9198 45.3131 9.33285C43.3298 8.31413 42.1152 7.62721 42.1152 6.58488C42.1385 5.6373 43.1425 4.66674 45.3813 4.66674C47.2248 4.6192 48.5792 5.06907 49.6053 5.51925L50.1181 5.75567L50.8893 0.947893Z" fill="#00579F"/>
                                                    <path d="M58.4259 14.7806C58.8929 13.5015 60.6898 8.55116 60.6898 8.55116C60.6663 8.59869 61.1559 7.24847 61.4359 6.41958L61.8322 8.33803C61.8322 8.33803 62.906 13.6674 63.1392 14.7806C62.2529 14.7806 59.5459 14.7806 58.4259 14.7806ZM65.4254 0.403564H61.0393C59.6867 0.403564 58.6591 0.805891 58.0755 2.25087L49.6527 22.6679H55.6026C55.6026 22.6679 56.5821 19.9199 56.7927 19.328C57.4454 19.328 63.2334 19.328 64.0731 19.328C64.2359 20.1097 64.7497 22.6679 64.7497 22.6679H70.0001L65.4254 0.403564Z" fill="#00579F"/>
                                                    <path d="M19.9266 0.403564L14.3733 15.5859L13.7665 12.5067C12.7398 8.9538 9.51988 5.0936 5.92664 3.17421L11.0132 22.6446H17.0096L25.9227 0.403564H19.9266Z" fill="#00579F"/>
                                                    <path d="M9.2166 0.403564H0.0933346L0 0.853427C7.11672 2.70105 11.83 7.15466 13.7664 12.5077L11.7832 2.27511C11.4566 0.853113 10.4532 0.450471 9.2166 0.403564Z" fill="#FAA61A"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0">
                                                        <rect width="70" height="23" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span class="pan" v-text="item.pan"></span>
                                        </div>
                                        <div class="status w-100">
                                            <span v-if="item.last_used_at">
                                                {{ $t('Последнее использование') }}:
                                                <span v-text="item.last_used_at"></span>
                                            </span>
                                            <span v-else>
                                                {{ $t('Не использовалась') }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="actions-side">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="border-top w-100 pt-3">
                        <p v-if="cards.length == 0">{{ $t('pay_card_verif_desc') }}</p>
                        <div class="total-amount">
                            <span>{{ $t('К оплате') }}:</span>
                            <div class="price">{{ totalPrice | money }} <i class="fas fa-hryvnia"></i></div>
                        </div>
                        <form id="newCardForm" method="POST" :action="formAction">
                            <template v-for="(value, key) in formData">
                                <input type="hidden" v-if="value" :name="key" :key="key" :value="value">
                            </template>
                        </form>
                        <button class="btn btn-success btn-lg mt-3" :disabled="loading" @click.prevent="select"><i class="fas fa-spin fa-spinner mr-1" v-if="loading"></i> Продолжить</button>
                        <hr>
                        <p class="text-muted agreement-info">{{ $t('Подписка') }} {{ plan.name }} {{ $t('подразумевает') }} {{ plan.period === 'year' ? $t('ежегодное') : $t('ежемесячное') }} {{ $t('автоматическое продление') }}. {{ $t('Подключая подписку, вы принимаете условия') }} <a href="#" target="_blank">{{ $t('пользовательского соглашения') }}</a>. {{ $t('Вы всегда можете отказаться от подписки в разделе управления подписками') }}.</p>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { EventBus } from '../../event-bus';
import "./styles.scss";

export default {
    name: "NewSubscription",

    mounted() {
        this.loadCurrent();
        this.loadCards();

        document.getElementById('page-content-wrapper').addEventListener('scroll', this.scrollStickyTop);
    },

    beforeDestroy() {
        document.getElementById('page-content-wrapper').removeEventListener('scroll', this.scrollStickyTop);
    },

	data: function() {
        return {
            id: this.$route.params.id,
            plan: {},

            cards: [],
            card: {},

            formData: {},
            formAction: null,

            promoInput: null,

            coupon: null,

            loading: false,

            waitingInterval: null,
        };
    },

    computed: {
        promoBtnDisabled() {
            return this.promoInput === null || this.promoInput === "" || this.promoInput === " ";
        },

        totalPrice() {
            let basePrice = this.plan.price;

            if(this.plan.period === "year") {
                basePrice = basePrice * 12;
            }

            if(this.coupon === null) {
                return basePrice;
            }

            if(this.coupon.discount === 0) {
                return basePrice;
            }

            if(basePrice === 0) {
                return basePrice;
            }

            return basePrice - (basePrice * (this.coupon.discount / 100));
        },
    },

    methods: {
        checkPromoCode() {
            axios.post(`/coupon/${this.promoInput}`)
                .then(({data}) => {
                    this.coupon = data.data;

                    this.$ga.event('promoCodes', 'checkPromoCode', this.promoInput);
                }).catch(({response}) => {
                    console.log(response);

                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');
                });
        },

        loadCurrent() {
            axios.get(`/subscription/${this.id}`)
                .then(({data}) => {
                    this.plan = data.data;
                });
        },

        loadCards() {
            axios.get('/cards')
                .then(({data}) => {
                    this.cards = data.data;

                    if(this.cards.length > 0) {
                        this.card = this.cards[0];
                    }
                });
        },

        addCard() {
            return new Promise((resolve, reject) => {
                axios.post('/cards', this.card)
                    .then(({data}) => {
                        this.formData = data.data.formData;
                        this.formAction = data.data.formAction;
                        this.card = data.data.card;

                        resolve();
                    });
            });
        },

        checkPayStatus(id) {
            axios.get(`/payment/${id}`)
                .then(({data}) => {
                    if(data.data.status) {
                        this.$router.push('/subscription#success');
                    }
                }).catch(({response}) => {
                    console.log(response);

                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');
                });
        },

        select() {
            if(this.loading) {
                return;
            }

            this.loading = true;

            const doAction = () => {
                axios.post(`/subscription/select/${this.id}`, {
                    coupon: this.coupon,
                    card: this.card,
                })
                    .then(({data}) => {
                        if(! this.card.pan) {
                            this.$ga.event('paySubscription', 'newCard', 'Submit Card Form');

                            return document.getElementById('newCardForm').submit();
                        }

                        this.$ga.event('paySubscription', 'pay', this.id);

                        this.waitingInterval = setInterval(() => this.checkPayStatus(data.data.payment), 2000);
                    }).catch(({response}) => {
                        console.log(response);

                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');
                    });
            };

            if(this.cards.length === 0) {
                return this.addCard().then(doAction);
            }

            doAction();
        },
    },


    beforeDestroy() {
        clearInterval(this.waitingInterval);
    }
};
</script>

<style lang="scss">
main {
    @media (max-width: 991px) {
        padding: 0;
        padding-top: 15px;
    }
}

.subscriptions-container {
    /* iphone X , XS, 11 Pro */
    @media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (-webkit-device-pixel-ratio: 3) { padding-bottom: 35px; }

    /* iphone XR, 11 */
    @media only screen and (min-device-width : 414px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 2) { padding-bottom: 35px; }

    /* iphone XS Max, 11 Pro Max */
    @media only screen and (min-device-width : 414px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 3) { padding-bottom: 35px; }
}

.coupon-form-block {
    @media (max-width: 991px) {
        margin-bottom: 15px;
    }
}

.user-cards {
    .col-lg-6:nth-child(2n) {
        padding-right: 0;
    }
    
    .col-lg-6:nth-child(2n-1) {
        padding-left: 0;
    }
}
</style>